// --------------------------------------------------------------
// Created On: 2026-10-27
// Author: Zachary Thomas
//
// Last Modified: 2026-10-27
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// In place operation that enforces valid values and comparators on a highlighting rule for all value types.
export default function enforceHighlightingRuleValueType(
  value: string,
  valueType: string,
  comparator: string,
  highlightingRule: GenericHighlightingRule
): void {
  switch (valueType) {
    case "NUMBER":
      if (comparator !== "<>") {
        highlightingRule.value = value.split(",")[0];
      }
      break;
    case "MAX":
      highlightingRule.comparator = "=";
      highlightingRule.value = value.split(",")[0];
      break;
    case "MIN":
      highlightingRule.comparator = "=";
      highlightingRule.value = value.split(",")[0];
      break;
    case "MEDIAN":
      if (comparator === "<>") {
        highlightingRule.comparator = ">";
      }
      highlightingRule.value = value.split(",")[0];
      break;
    case "MEAN":
      if (comparator === "<>") {
        highlightingRule.comparator = ">";
      }
      highlightingRule.value = value.split(",")[0];
      break;
    case "STANDARD_DEVIATION":
      if (comparator === "<>" || comparator === "=") {
        highlightingRule.comparator = ">";
      }
      if (!["1", "2", "3"].includes(value)) {
        highlightingRule.value = "1";
      }
      break;
  }
}

interface GenericHighlightingRule {
  comparator: string;
  value: string;
}
